import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BookingsPageComponent } from './pages/bookings-page/bookings-page.component';
import { BookingsImportPageComponent } from './pages/bookings-import-page/bookings-import-page.component';
import { BookingImportDetailPageComponent } from './pages/booking-import-detail-page/booking-import-detail-page.component';
import { BookingPermission } from '../core/models/entities/permission';

const routes: Routes = [
  { path: '', component: BookingsPageComponent, title: 'page-title.bookings' },
  {
    path: 'import',
    component: BookingsImportPageComponent,
    title: 'bookings.import.page-title',
    data: { manager: true, requiredPermission: BookingPermission.Import },
  },
  {
    path: 'import/:id',
    component: BookingImportDetailPageComponent,
    title: 'bookings.import.detail-title',
    data: { manager: true, requiredPermission: BookingPermission.Import },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BookingsRoutingModule {}
